import { store } from 'redux/store';
import { authInitState } from 'redux/reducers/auth/reducer';
import { REDIRECT_URL } from 'services/constants/env';
import { IAxiosError, IAxiosRequestConfig } from './types';

// ==========================================:
export const onError = (error: IAxiosError) => {
	const status = error.response ? error.response.status : null;
	const errorResponse: IAxiosRequestConfig = error.config;
	const state = store.getState();

	const host = document.location.hostname;
	const hostKeycloak =
		host === 'gpsr.easproject.com' ? 'id.easproject.com' : 'id-dev.easproject.com';

	const ID_URL = `https://${hostKeycloak}/auth/realms/dashboard/protocol/openid-connect/auth?response_type=code&client_id=dashboard-ui&redirect_uri=${
		REDIRECT_URL ?? 'http://localhost:3000'
	}`;

	// window.location.assign(ID_URL);

	if (status === 401 && !errorResponse._retry) {
		// console.log('onError 401', state.auth);
		store.dispatch(authInitState());
		// store.dispatch(saveUrl(window.location.pathname + window.location.search));
		// window.location.assign(ID_URL);
	}

	return Promise.reject(error);
};
